import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgShowChart = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1024 1024",
	fill: "none",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M150 788l-64-64 320-320 170 172 302-340 60 60-362 408-170-172z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgShowChart);
export default ForwardRef;
